/* ==========================================================================
   Falsematter theme layer (fm-*) — behaviour
   Header, nav drawer, announcement, carousels, tabs, feature cards, footer
   accordion, sticky bars, video, product form + gallery, AJAX cart drawer.
   ========================================================================== */
(function () {
  'use strict';
  const FM = (window.FM = window.FM || {});
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  FM.money = function (cents, format) {
    const fmt = format || FM.moneyFormat || '${{amount}}';
    const value = Number(cents || 0) / 100;
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    let out;
    const fixed = (n, d, t, s) => {
      const parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(s);
    };
    switch (key) {
      case 'amount_no_decimals':
        out = fixed(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = fixed(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = fixed(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        out = fixed(value, 2, "'", '.');
        break;
      default:
        out = fixed(value, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  };

  /* ---------- toast ---------- */
  let toastEl;
  FM.toast = function (msg, ms = 2200) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fm-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), ms);
  };

  /* ---------- header ---------- */
  function initHeader() {
    const header = $('[data-fm-header]');
    const announce = $('[data-fm-announce]');
    const root = document.documentElement;
    const setVars = () => {
      const hh = header ? header.offsetHeight : 0;
      const ah = announce && !announce.classList.contains('is-dismissed') ? announce.offsetHeight : 0;
      root.style.setProperty('--fm-header-h', hh + 'px');
      root.style.setProperty('--fm-announce-h', ah + 'px');
    };
    setVars();
    on(window, 'resize', setVars);
    if (!header) return;
    let lastY = window.scrollY;
    const scrollUp = header.classList.contains('fm-header--scroll-up');
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      if (scrollUp) {
        if (y > lastY && y > 120) header.classList.add('is-hidden');
        else header.classList.remove('is-hidden');
      }
      lastY = y;
    };
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();

    // nav drawer
    const drawer = $('[data-fm-nav-drawer]');
    const openBtns = $$('[data-fm-nav-open]');
    const closeBtns = $$('[data-fm-nav-close]');
    const open = () => {
      if (!drawer) return;
      drawer.classList.add('is-open');
      header.classList.add('is-open');
      document.body.classList.add('fm-lock');
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
    };
    const close = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      header.classList.remove('is-open');
      document.body.classList.remove('fm-lock');
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    };
    openBtns.forEach((b) => on(b, 'click', open));
    closeBtns.forEach((b) => on(b, 'click', close));
    on(document, 'keydown', (e) => e.key === 'Escape' && close());
    $$('[data-fm-nav-sub]', drawer || document).forEach((btn) => {
      on(btn, 'click', () => {
        const item = btn.closest('.fm-nav-drawer__item');
        const isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
    FM.closeNav = close;
  }

  /* ---------- announcement ---------- */
  function initAnnouncement() {
    $$('[data-fm-announce]').forEach((bar) => {
      const key = 'fm-announce-dismissed-' + (bar.dataset.key || '1');
      if (bar.dataset.dismissible === 'true' && sessionStorage.getItem(key)) bar.classList.add('is-dismissed');
      on($('[data-fm-announce-close]', bar), 'click', () => {
        bar.classList.add('is-dismissed');
        try {
          sessionStorage.setItem(key, '1');
        } catch (e) {}
        window.dispatchEvent(new Event('resize'));
      });
      const msgs = $('[data-rotate]', bar);
      if (msgs) {
        const items = $$('.fm-announce__msg', msgs);
        if (items.length < 2) {
          items.forEach((i) => i.classList.add('is-active'));
          return;
        }
        let i = 0;
        items[0].classList.add('is-active');
        const ms = Number(msgs.dataset.rotate) || 5000;
        setInterval(() => {
          items[i].classList.remove('is-active');
          i = (i + 1) % items.length;
          items[i].classList.add('is-active');
        }, ms);
      }
    });
  }

  /* ---------- carousel ---------- */
  function initCarousel(wrap) {
    const track = $('[data-fm-track]', wrap) || wrap;
    const items = Array.from(track.children).filter((c) => !c.hidden);
    if (!items.length) return;
    const dotsEl = $('[data-fm-dots]', wrap);
    const prev = $('[data-fm-prev]', wrap);
    const next = $('[data-fm-next]', wrap);
    const counter = $('[data-fm-counter]', wrap);
    let dots = [];
    if (dotsEl) {
      dotsEl.innerHTML = '';
      dots = items.map((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        on(b, 'click', () => scrollTo(i));
        dotsEl.appendChild(b);
        return b;
      });
    }
    const index = () => {
      let best = 0;
      let bestD = Infinity;
      const left = track.scrollLeft + parseFloat(getComputedStyle(track).scrollPaddingInlineStart || 0);
      items.forEach((it, i) => {
        const d = Math.abs(it.offsetLeft - left);
        if (d < bestD) {
          bestD = d;
          best = i;
        }
      });
      return best;
    };
    const scrollTo = (i) => {
      i = Math.max(0, Math.min(items.length - 1, i));
      const pad = parseFloat(getComputedStyle(track).scrollPaddingInlineStart || 0);
      track.scrollTo({ left: items[i].offsetLeft - pad, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    const update = () => {
      const i = index();
      dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
      if (counter) counter.textContent = i + 1 + ' / ' + items.length;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prev) prev.disabled = i === 0 && track.scrollLeft < 4;
      if (next) next.disabled = atEnd;
      const isGrid = getComputedStyle(track).display === 'grid';
      const overflow = track.scrollWidth > track.clientWidth + 4;
      [dotsEl, prev, next].forEach((el) => el && (el.style.display = isGrid || !overflow ? 'none' : ''));
      wrap.dispatchEvent(new CustomEvent('fm:slide', { detail: { index: i } }));
    };
    // expose current closures so listeners bound once keep working after a re-init
    wrap._pcScrollTo = scrollTo;
    wrap._pcUpdate = update;
    wrap._pcIndex = index;
    wrap._pcCount = items.length;
    if (!wrap._pcBound) {
      wrap._pcBound = true;
      on(prev, 'click', () => wrap._pcScrollTo(wrap._pcIndex() - 1));
      on(next, 'click', () => wrap._pcScrollTo(wrap._pcIndex() + 1));
      let raf;
      on(track, 'scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => wrap._pcUpdate());
      }, { passive: true });
      on(window, 'resize', () => wrap._pcUpdate());
      // autoplay
      const auto = Number(wrap.dataset.pcAutoplay || 0);
      if (auto > 0 && !reduceMotion) {
        const tick = () => wrap._pcScrollTo((wrap._pcIndex() + 1) % wrap._pcCount);
        let t = setInterval(tick, auto * 1000);
        on(wrap, 'pointerenter', () => clearInterval(t));
        on(wrap, 'pointerleave', () => (t = setInterval(tick, auto * 1000)));
      }
    }
    update();
  }

  /* ---------- feature card toggles ---------- */
  function initToggles(root = document) {
    $$('[data-fm-toggle]', root).forEach((btn) => {
      on(btn, 'click', (e) => {
        e.preventDefault();
        const card = btn.closest(btn.dataset.pcToggle || '.fm-feat__card');
        const open = card.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- tabs ---------- */
  function initTabs(root = document) {
    $$('[data-fm-tabs]', root).forEach((wrap) => {
      const tabs = $$('[role="tab"]', wrap);
      const panels = $$('[role="tabpanel"]', wrap);
      const select = (i) => {
        tabs.forEach((t, j) => t.setAttribute('aria-selected', j === i ? 'true' : 'false'));
        panels.forEach((p, j) => p.classList.toggle('is-active', j === i));
        tabs[i] && tabs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      tabs.forEach((t, i) => on(t, 'click', () => select(i)));
      select(0);
      const auto = Number(wrap.dataset.pcTabsAuto || 0);
      if (auto > 0) {
        let i = 0;
        let timer = setInterval(() => select((i = (i + 1) % tabs.length)), auto * 1000);
        on(wrap, 'click', () => clearInterval(timer));
      }
    });
  }

  /* ---------- footer accordion ---------- */
  function initFooter(root = document) {
    $$('[data-fm-footer-acc]', root).forEach((btn) => {
      on(btn, 'click', () => {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        const col = btn.closest('.fm-footer__col');
        const open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- sticky bars ---------- */
  function initSticky(root = document) {
    $$('[data-fm-sticky]', root).forEach((bar) => {
      const after = bar.dataset.after || '600';
      const target = /^\d+$/.test(after) ? null : $(after);
      const check = () => {
        let show;
        if (target) {
          const r = target.getBoundingClientRect();
          show = r.bottom < 0;
        } else show = window.scrollY > Number(after);
        if (bar.dataset.hideNearEnd === 'true') {
          const nearEnd = window.innerHeight + window.scrollY > document.body.scrollHeight - 300;
          if (nearEnd) show = false;
        }
        bar.classList.toggle('is-visible', show);
      };
      on(window, 'scroll', check, { passive: true });
      on(window, 'resize', check);
      check();
    });
  }

  /* ---------- reveal ---------- */
  function initReveal(root = document) {
    const els = $$('.fm-reveal', root);
    if (!els.length || !('IntersectionObserver' in window)) return els.forEach((e) => e.classList.add('is-in'));
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => en.isIntersecting && (en.target.classList.add('is-in'), io.unobserve(en.target))),
      { rootMargin: '0px 0px -10% 0px' }
    );
    els.forEach((e) => io.observe(e));
  }

  /* ---------- video ---------- */
  function initVideo(root = document) {
    $$('[data-fm-video]', root).forEach((wrap) => {
      const play = $('[data-fm-play]', wrap);
      const start = () => {
        wrap.classList.add('is-playing');
        const tpl = $('template', wrap);
        if (tpl) {
          const frame = $('.fm-video__frame', wrap);
          frame.appendChild(tpl.content.cloneNode(true));
          const v = $('video', frame);
          if (v) v.play().catch(() => {});
        } else {
          const v = $('video', wrap);
          if (v) v.play().catch(() => {});
        }
      };
      on(play, 'click', start);
      if (wrap.dataset.autoplay === 'true') start();
    });
  }

  /* ---------- scroll to anchor ---------- */
  function initScroll(root = document) {
    $$('[data-fm-scroll]', root).forEach((a) => {
      on(a, 'click', (e) => {
        const href = a.getAttribute('href') || '';
        const id = href.includes('#') ? href.split('#')[1] : '';
        const t = id && document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        const top = t.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--fm-header-h')) || 0);
        window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
        FM.closeNav && FM.closeNav();
      });
    });
  }

  /* ==========================================================================
     CART
     ========================================================================== */
  const cart = (FM.cart = {
    sectionId: 'fm-cart-drawer',
    busy: false,
    get drawer() {
      return $('[data-fm-cart-drawer]');
    },
    open() {
      const d = this.drawer;
      if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fm-lock');
      const c = $('[data-cart-close]', d);
      c && c.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('fm:cart:open'));
    },
    close() {
      const d = this.drawer;
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fm-lock');
    },
    toggle() {
      const d = this.drawer;
      if (!d) return;
      d.classList.contains('is-open') ? this.close() : this.open();
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = n;
        el.dataset.count = n;
      });
    },
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong');
      return data;
    },
    render(sections) {
      const html = sections && sections[this.sectionId];
      const d = this.drawer;
      if (!html || !d) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cart-inner]', doc);
      const cur = $('[data-cart-inner]', d);
      if (fresh && cur) {
        cur.replaceWith(fresh);
        this.bind();
      }
    },
    async refresh() {
      try {
        const res = await fetch(`${FM.routes.root || '/'}?sections=${this.sectionId}`, { headers: { Accept: 'application/json' } });
        const sections = await res.json();
        this.render(sections);
        const c = await fetch(`${FM.routes.cart || '/cart'}.js`).then((r) => r.json());
        this.setCount(c.item_count);
      } catch (e) {
        console.warn('[fm] cart refresh failed', e);
      }
    },
    async add(items, { open = true, button, silent = false } = {}) {
      if (this.busy) return;
      this.busy = true;
      button && button.classList.add('is-loading');
      try {
        const data = await this.request(`${FM.routes.cart || '/cart'}/add.js`, { items, sections: this.sectionId });
        const c = await fetch(`${FM.routes.cart || '/cart'}.js`).then((r) => r.json());
        this.setCount(c.item_count);
        this.render(data.sections);
        document.dispatchEvent(new CustomEvent('fm:cart:added', { detail: { items, cart: c } }));
        if (open) {
          if (this.drawer) this.open();
          else window.location.href = FM.routes.cart || '/cart';
        } else if (!silent) FM.toast('Added to bag');
        return c;
      } catch (e) {
        FM.toast(e.message || 'Could not add to cart', 3200);
        throw e;
      } finally {
        this.busy = false;
        button && button.classList.remove('is-loading');
      }
    },
    async change(key, quantity, lineEl) {
      lineEl && lineEl.classList.add('is-loading');
      try {
        const data = await this.request(`${FM.routes.cart || '/cart'}/change.js`, { id: key, quantity, sections: this.sectionId });
        this.setCount(data.item_count);
        this.render(data.sections);
        // cart page re-render
        const page = $('[data-fm-cart-page]');
        if (page) window.location.reload();
        document.dispatchEvent(new CustomEvent('fm:cart:changed', { detail: { cart: data } }));
      } catch (e) {
        FM.toast(e.message || 'Could not update cart', 3200);
        lineEl && lineEl.classList.remove('is-loading');
      }
    },
    async note(text) {
      try {
        await this.request(`${FM.routes.cart || '/cart'}/update.js`, { note: text });
      } catch (e) {}
    },
    bind() {
      const scope = this.drawer || document;
      $$('[data-cart-close]', scope).forEach((b) => (b.onclick = () => this.close()));
      $$('[data-line-key]', document).forEach((line) => {
        if (line._bound) return;
        line._bound = true;
        const key = line.dataset.lineKey;
        const input = $('[data-qty-input]', line);
        const val = () => Math.max(0, parseInt(input && input.value, 10) || 0);
        const minus = $('[data-qty-minus]', line);
        const plus = $('[data-qty-plus]', line);
        const remove = $('[data-line-remove]', line);
        on(minus, 'click', () => this.change(key, val() - 1, line));
        on(plus, 'click', () => this.change(key, val() + 1, line));
        on(input, 'change', () => this.change(key, val(), line));
        on(remove, 'click', (e) => {
          e.preventDefault();
          this.change(key, 0, line);
        });
      });
      const note = $('[data-cart-note]', scope);
      if (note && !note._bound) {
        note._bound = true;
        let t;
        on(note, 'input', () => {
          clearTimeout(t);
          t = setTimeout(() => this.note(note.value), 500);
        });
      }
      const disc = $('[data-cart-discount-form]', scope);
      if (disc && !disc._bound) {
        disc._bound = true;
        on(disc, 'submit', (e) => {
          e.preventDefault();
          const code = ($('input', disc).value || '').trim();
          const btn = $('[data-cart-checkout]', scope);
          if (!btn) return;
          const base = btn.dataset.href || btn.getAttribute('href') || '/checkout';
          btn.dataset.href = base;
          btn.setAttribute('href', code ? base + (base.includes('?') ? '&' : '?') + 'discount=' + encodeURIComponent(code) : base);
          FM.toast(code ? 'Code will apply at checkout' : 'Code removed');
        });
      }
    },
  });

  function initCart() {
    cart.bind();
    on(document, 'click', (e) => {
      const openBtn = e.target.closest('[data-fm-cart-open]');
      if (openBtn && cart.drawer) {
        e.preventDefault();
        cart.open();
        return;
      }
      const back = e.target.closest('[data-cart-backdrop]');
      if (back) cart.close();
      const add = e.target.closest('[data-fm-add]');
      if (add) {
        e.preventDefault();
        const id = Number(add.dataset.pcAdd);
        const qty = Number(add.dataset.qty || 1);
        if (id) cart.add([{ id, quantity: qty }], { button: add, open: add.dataset.open !== 'false' });
      }
    });
    on(document, 'keydown', (e) => e.key === 'Escape' && cart.close());
    // theme editor: open drawer when its section is selected
    on(document, 'shopify:section:select', (e) => {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-fm-cart-drawer]')) cart.open();
    });
    on(document, 'shopify:section:deselect', (e) => {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-fm-cart-drawer]')) cart.close();
    });
    // optional: open on page load if ?cart=open
    if (location.search.includes('cart=open')) cart.open();
  }

  /* ==========================================================================
     PRODUCT
     ========================================================================== */
  function initProduct(root) {
    const data = $('[data-fm-variants]', root);
    if (!data) return;
    let variants = [];
    try {
      variants = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    const form = $('form.fm-buybox__form', root) || $('form[action*="/cart/add"]', root);
    const idInput = form && $('input[name="id"]', form);
    const optionGroups = $$('[data-fm-option]', root);
    const priceNow = $$('[data-fm-price]', root);
    const priceWas = $$('[data-fm-compare]', root);
    const saveEls = $$('[data-fm-save]', root);
    const atcBtns = $$('[data-fm-atc]', root);
    const stockEl = $('[data-fm-stock]', root);
    const skuEl = $('[data-fm-sku]', root);
    const qtyInput = $('[data-fm-qty]', root);
    const gallery = $('[data-fm-gallery]', root);
    const galleryItems = gallery ? $$('[data-gallery-item]', gallery) : [];
    const moneyFmt = root.dataset.moneyFormat || FM.moneyFormat;
    const labels = {
      add: root.dataset.labelAdd || 'Add to cart',
      soldOut: root.dataset.labelSoldOut || 'Sold out',
      unavailable: root.dataset.labelUnavailable || 'Unavailable',
      inStock: root.dataset.labelInStock || 'In stock — ships in 1–2 business days',
      lowStock: root.dataset.labelLowStock || 'Only [count] left',
      outStock: root.dataset.labelOutStock || 'Out of stock',
    };
    const optionCount = optionGroups.length;

    const selected = () => optionGroups.map((g) => {
      const c = $('[aria-checked="true"]', g);
      return c ? c.dataset.value : null;
    });
    const findVariant = (opts) => variants.find((v) => opts.every((o, i) => o == null || v.options[i] === o));
    let current = variants.find((v) => String(v.id) === String(idInput && idInput.value)) || variants.find((v) => v.available) || variants[0];

    function markAvailability(opts) {
      optionGroups.forEach((g, gi) => {
        $$('[data-value]', g).forEach((btn) => {
          const test = opts.slice();
          test[gi] = btn.dataset.value;
          const v = variants.find((vv) => vv.options.every((o, i) => (i === gi ? o === test[gi] : test[i] == null || o === test[i])));
          const exists = !!v;
          const avail = !!variants.find((vv) => vv.available && vv.options.every((o, i) => (i === gi ? o === test[gi] : test[i] == null || o === test[i])));
          btn.classList.toggle('is-unavailable', exists && !avail);
          btn.disabled = !exists;
        });
      });
    }

    function filterGallery(v) {
      if (!galleryItems.length) return;
      const colorIdx = optionGroups.findIndex((g) => /colou?r|style|band|strap|finish/i.test(g.dataset.pcOption || ''));
      const value = colorIdx >= 0 && v ? (v.options[colorIdx] || '').toLowerCase() : '';
      // every colour value of the option; an image is "tagged" when its alt names any of them
      const allValues = colorIdx >= 0 ? $$('[data-value]', optionGroups[colorIdx]).map((b) => (b.dataset.value || '').toLowerCase()).filter(Boolean) : [];
      const isTagged = (alt) => allValues.some((c) => alt.includes(c));
      const matches = value ? galleryItems.filter((it) => (it.dataset.alt || '').toLowerCase().includes(value)) : [];
      galleryItems.forEach((it) => {
        const alt = (it.dataset.alt || '').toLowerCase();
        let show = true;
        if (value && matches.length) show = alt.includes(value) || !isTagged(alt);
        it.hidden = !show;
      });
      const wrap = gallery.closest('[data-fm-carousel]') || gallery;
      initCarousel(wrap);
      initGallery(gallery, true);
      // jump to variant image
      if (v && v.featured_media_id) {
        const i = galleryItems.filter((it) => !it.hidden).findIndex((it) => String(it.dataset.mediaId) === String(v.featured_media_id));
        if (i >= 0 && wrap._pcScrollTo) wrap._pcScrollTo(i);
      }
    }

    function render(v, opts) {
      current = v;
      markAvailability(opts);
      if (idInput) idInput.value = v ? v.id : '';
      priceNow.forEach((el) => (el.textContent = v ? FM.money(v.price, moneyFmt) : ''));
      priceWas.forEach((el) => {
        const show = v && v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !show;
        if (show) el.textContent = FM.money(v.compare_at_price, moneyFmt);
      });
      // value stack: keep today's price, savings and meter in sync with the variant
      $('[data-fm-vs]', root).forEach((vs) => {
        const total = Number(vs.dataset.total || 0);
        const price = v ? v.price : 0;
        const save = total - price;
        const p = $('[data-fm-vs-price]', vs); if (p && v) p.textContent = FM.money(price, moneyFmt);
        const fill = $('[data-fm-vs-fill]', vs); if (fill && total) fill.style.width = Math.min(100, Math.round((price / total) * 100)) + '%';
        const sv = $('[data-fm-vs-save] span', vs);
        if (sv && save > 0) sv.textContent = sv.textContent.replace(/$[d,.]+/, FM.money(save, moneyFmt)).replace(/(d+%)/, '(' + Math.floor((save / total) * 100) + '%)');
      });
      saveEls.forEach((el) => {
        const show = v && v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !show;
        if (show) {
          const pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          el.textContent = el.dataset.mode === 'amount' ? 'Save ' + FM.money(v.compare_at_price - v.price, moneyFmt) : 'Save ' + pct + '%';
        }
      });
      atcBtns.forEach((b) => {
        const label = $('.fm-btn__label', b) || b;
        if (!v) {
          b.disabled = true;
          label.textContent = labels.unavailable;
        } else if (!v.available) {
          b.disabled = true;
          label.textContent = labels.soldOut;
        } else {
          b.disabled = false;
          label.textContent = b.dataset.label || labels.add;
        }
      });
      if (stockEl) {
        stockEl.classList.remove('is-low', 'is-out');
        if (!v || !v.available) {
          stockEl.textContent = labels.outStock;
          stockEl.classList.add('is-out');
        } else if (v.inventory_quantity > 0 && v.inventory_quantity <= Number(stockEl.dataset.lowAt || 5) && v.inventory_management) {
          stockEl.textContent = labels.lowStock.replace('[count]', v.inventory_quantity);
          stockEl.classList.add('is-low');
        } else stockEl.textContent = labels.inStock;
      }
      if (skuEl) skuEl.textContent = v && v.sku ? v.sku : '';
      $$('[data-fm-variant-title]', root).forEach((el) => (el.textContent = v ? v.title : ''));
      $$('[data-fm-sticky-img]', root).forEach((img) => v && v.featured_image && (img.src = v.featured_image));
      if (v && history.replaceState && root.dataset.updateUrl !== 'false') {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      filterGallery(v);
      root.dispatchEvent(new CustomEvent('fm:variant', { detail: { variant: v } }));
    }

    optionGroups.forEach((g, gi) => {
      $$('[data-value]', g).forEach((btn) => {
        on(btn, 'click', () => {
          $$('[data-value]', g).forEach((b) => b.setAttribute('aria-checked', 'false'));
          btn.setAttribute('aria-checked', 'true');
          const lbl = $('[data-fm-option-value]', g);
          if (lbl) lbl.textContent = btn.dataset.value;
          let opts = selected();
          let v = findVariant(opts);
          if (!v) {
            // pick first available combo keeping this choice
            v = variants.find((vv) => vv.options[gi] === btn.dataset.value && vv.available) || variants.find((vv) => vv.options[gi] === btn.dataset.value);
            if (v) {
              optionGroups.forEach((g2, j) => {
                $$('[data-value]', g2).forEach((b) => b.setAttribute('aria-checked', b.dataset.value === v.options[j] ? 'true' : 'false'));
                const l2 = $('[data-fm-option-value]', g2);
                if (l2) l2.textContent = v.options[j];
              });
              opts = v.options.slice();
            }
          }
          render(v, opts);
        });
      });
    });

    // quantity
    const qtyWrap = qtyInput && qtyInput.closest('.fm-qty');
    if (qtyWrap) {
      on($('[data-qty-minus]', qtyWrap), 'click', () => (qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1)));
      on($('[data-qty-plus]', qtyWrap), 'click', () => (qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1));
    }

    // submit
    if (form) {
      on(form, 'submit', (e) => {
        e.preventDefault();
        if (!current || !current.available) return;
        const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        const props = {};
        $$('[name^="properties["]', form).forEach((i) => {
          if (i.type === 'checkbox' && !i.checked) return;
          const k = i.name.replace(/^properties\[(.+)\]$/, '$1');
          if (i.value) props[k] = i.value;
        });
        const plan = $('[name="selling_plan"]:checked', form) || $('[name="selling_plan"]', form);
        const item = { id: current.id, quantity: qty };
        if (Object.keys(props).length) item.properties = props;
        if (plan && plan.value) item.selling_plan = plan.value;
        const btn = e.submitter && e.submitter.matches('[data-fm-atc]') ? e.submitter : atcBtns[0];
        const mode = (btn && btn.dataset.mode) || 'cart';
        cart.add([item], { button: btn, open: mode !== 'checkout' }).then(() => {
          if (mode === 'checkout') window.location.href = (FM.routes.checkout || '/checkout');
        }).catch(() => {});
      });
    }
    // sticky bar buttons submit main form
    $$('[data-fm-sticky-submit]', root).forEach((b) => on(b, 'click', () => form && form.requestSubmit()));

    // sticky ATC visibility
    const sticky = $('[data-fm-sticky-atc]', root);
    const mainBtn = $('[data-fm-atc-main]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => {
        const visible = en[0].isIntersecting;
        const r = mainBtn.getBoundingClientRect();
        sticky.classList.toggle('is-visible', !visible && r.top < 0);
      });
      io.observe(mainBtn);
    }

    render(current, current ? current.options.slice() : selected());
  }

  /* ---------- gallery ---------- */
  function initGallery(gallery, rebind) {
    if (!gallery) return;
    const items = $$('[data-gallery-item]', gallery).filter((i) => !i.hidden);
    const thumbsEl = $('[data-fm-thumbs]', gallery);
    const wrap = gallery.closest('[data-fm-carousel]') || gallery;
    if (thumbsEl) {
      thumbsEl.innerHTML = '';
      items.forEach((it, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fm-gallery__thumb';
        b.setAttribute('aria-label', 'Image ' + (i + 1));
        const src = it.dataset.thumb;
        if (src) {
          const img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.loading = 'lazy';
          b.appendChild(img);
        } else b.textContent = i + 1;
        on(b, 'click', () => wrap._pcScrollTo && wrap._pcScrollTo(i));
        thumbsEl.appendChild(b);
      });
      const thumbs = $$('.fm-gallery__thumb', thumbsEl);
      on(wrap, 'fm:slide', (e) => thumbs.forEach((t, j) => t.setAttribute('aria-current', j === e.detail.index ? 'true' : 'false')));
      thumbs[0] && thumbs[0].setAttribute('aria-current', 'true');
    }
    if (rebind) return;
    // zoom
    const zoomBtn = $('[data-fm-zoom]', gallery);
    if (zoomBtn) {
      const dlg = document.createElement('dialog');
      dlg.className = 'fm-zoom';
      dlg.innerHTML = '<button type="button" class="fm-zoom__close" aria-label="Close"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg></button><div class="fm-zoom__track"></div>';
      document.body.appendChild(dlg);
      const openZoom = (start) => {
        const track = $('.fm-zoom__track', dlg);
        track.innerHTML = '';
        const vis = $$('[data-gallery-item]', gallery).filter((i) => !i.hidden);
        vis.forEach((it) => {
          const src = it.dataset.zoom;
          if (!src) return;
          const d = document.createElement('div');
          d.className = 'fm-zoom__item';
          d.innerHTML = '<img src="' + src + '" alt="">';
          track.appendChild(d);
        });
        dlg.showModal();
        const kids = Array.from(track.children);
        if (kids[start]) track.scrollLeft = kids[start].offsetLeft;
      };
      on(zoomBtn, 'click', () => {
        const i = Math.round(($('[data-fm-track]', gallery) || gallery).scrollLeft / (items[0] ? items[0].offsetWidth + 8 : 1));
        openZoom(i);
      });
      $$('[data-gallery-item]', gallery).forEach((it, i) => on(it, 'click', (e) => {
        if (it.dataset.zoom && !e.target.closest('video')) openZoom(i);
      }));
      on($('.fm-zoom__close', dlg), 'click', () => dlg.close());
      on(dlg, 'click', (e) => e.target === dlg && dlg.close());
    }
  }

  /* ---------- init all ---------- */
  function initAll(root = document) {
    $$('[data-fm-carousel]', root).forEach(initCarousel);
    initToggles(root);
    initTabs(root);
    initFooter(root);
    initSticky(root);
    initReveal(root);
    initVideo(root);
    initScroll(root);
    $$('[data-fm-product]', root).forEach((p) => {
      $$('[data-fm-gallery]', p).forEach((g) => initGallery(g));
      initProduct(p);
    });
    $$('[data-fm-gallery]', root).forEach((g) => !g.closest('[data-fm-product]') && initGallery(g));
    if (root !== document) cart.bind();
  }

  function boot() {
    FM.routes = FM.routes || { root: '/', cart: '/cart', checkout: '/checkout' };
    initHeader();
    initAnnouncement();
    initCart();
    initAll(document);
    on(document, 'shopify:section:load', (e) => {
      initAll(e.target);
      if (e.target.querySelector('[data-fm-header]')) initHeader();
      if (e.target.querySelector('[data-fm-announce]')) initAnnouncement();
    });
    on(document, 'shopify:block:select', (e) => {
      const item = e.target;
      const wrap = item.closest('[data-fm-carousel]');
      if (wrap && wrap._pcScrollTo) {
        const track = $('[data-fm-track]', wrap) || wrap;
        const i = Array.from(track.children).indexOf(item);
        if (i >= 0) wrap._pcScrollTo(i);
      }
      const tab = item.closest('[role="tabpanel"]');
      if (tab) {
        const tabsWrap = tab.closest('[data-fm-tabs]');
        const i = $$('[role="tabpanel"]', tabsWrap).indexOf(tab);
        const btn = $$('[role="tab"]', tabsWrap)[i];
        btn && btn.click();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ==========================================================================
   Falsematter extensions: collection filters, search overlay, product-grid arrows
   ========================================================================== */
(function () {
  const FM = (window.FM = window.FM || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, o);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function initFilters(root = document) {
    $$('[data-fm-filters]', root).forEach((form) => {
      if (form._fmBound) return;
      form._fmBound = true;
      let t;
      const go = () => { clearTimeout(t); t = setTimeout(() => (form.requestSubmit ? form.requestSubmit() : form.submit()), 300); };
      $$('input[type="checkbox"]', form).forEach((i) => on(i, 'change', go));
      $$('input[type="number"]', form).forEach((i) => on(i, 'change', go));
      $$('select', form).forEach((i) => on(i, 'change', () => (form.requestSubmit ? form.requestSubmit() : form.submit())));
    });
    const drawer = $('[data-fm-filters-drawer]', root) || $('[data-fm-filters-drawer]');
    $$('[data-fm-filters-open]', root).forEach((b) => on(b, 'click', () => { if (!drawer) return; drawer.classList.toggle('is-open'); if (window.innerWidth < 990) document.body.classList.toggle('fm-lock', drawer.classList.contains('is-open')); }));
    $$('[data-fm-filters-close]', root).forEach((b) => on(b, 'click', () => { drawer && drawer.classList.remove('is-open'); document.body.classList.remove('fm-lock'); }));
    $$('[data-fm-sort]', root).forEach((sel) => on(sel, 'change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString(); }));
  }

  function initPredictive() {
    const dlg = $('[data-fm-search]');
    if (!dlg || dlg._fmBound) return;
    dlg._fmBound = true;
    const input = $('[data-fm-search-input]', dlg);
    const out = $('[data-fm-search-results]', dlg);
    if (!input || !out) return;
    let t, ctrl;
    const root = (FM.routes && FM.routes.root && FM.routes.root !== '/') ? FM.routes.root.replace(/\/$/, '') : '';
    on(input, 'input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = root + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          const r = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } });
          const d = await r.json();
          const items = (d.resources && d.resources.results && d.resources.results.products) || [];
          const money = (p) => (FM.money ? FM.money(Math.round(parseFloat(p) * 100)) : p);
          out.innerHTML = items.map((p) => {
            const img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.includes('?') ? '&' : '?') + 'width=400' : '';
            return '<a class="fm-search__hit" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="fm-search__hit-img"></span>') + '<span class="fm-search__hit-title">' + esc(p.title) + '</span><span class="fm-search__hit-price">' + esc(money(p.price)) + '</span></a>';
          }).join('') + (items.length ? '<a class="fm-search__all" href="' + root + '/search?q=' + encodeURIComponent(q) + '&type=product">See all results →</a>' : '<p class="fm-search__none">No pieces found for “' + esc(q) + '”.</p>');
        } catch (e) { /* aborted */ }
      }, 220);
    });
    on(dlg, 'click', (e) => { if (e.target === dlg) dlg.close(); });
  }

  function initGridArrows(root = document) {
    $$('[data-fm-grid-nav]', root).forEach((nav) => {
      if (nav._fmBound) return;
      nav._fmBound = true;
      const track = $(nav.dataset.fmGridNav) || nav.previousElementSibling;
      if (!track) return;
      const step = () => { const first = track.children[0]; return first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) : 300; };
      on($('[data-prev]', nav), 'click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      on($('[data-next]', nav), 'click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  function init(root = document) { initFilters(root); initPredictive(); initGridArrows(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* ==========================================================================
   Falsematter: recently viewed (localStorage, no app needed)
   ========================================================================== */
(function () {
  const FM = (window.FM = window.FM || {});
  const KEY = 'fm-recent';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {} };
  const root = (FM.routes && FM.routes.root && FM.routes.root !== '/') ? FM.routes.root.replace(/\/$/, '') : '';

  function remember(handle) {
    if (!handle) return;
    const list = read().filter((h) => h !== handle);
    list.unshift(handle);
    write(list);
  }

  async function render(wrap) {
    const section = wrap.closest('.fm-recent');
    const grid = wrap.querySelector('[data-fm-recent-grid]');
    const limit = Number(wrap.dataset.limit || 6);
    const exclude = wrap.dataset.exclude || '';
    const handles = read().filter((h) => h !== exclude).slice(0, limit);
    if (!grid || !handles.length) return;
    const items = await Promise.all(handles.map((h) => fetch(root + '/products/' + h + '.js', { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
    const html = items.filter(Boolean).map((p) => {
      const img = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=600' : '';
      const price = FM.money ? FM.money(p.price) : (p.price / 100).toFixed(2);
      return '<a class="fm-recent__card" href="' + esc(p.url) + '">' + (img ? '<img class="fm-recent__img" src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="fm-recent__img"></span>') + '<span class="fm-recent__title">' + esc(p.title) + '</span><span class="fm-recent__price">' + esc(price) + '</span></a>';
    }).join('');
    if (!html) return;
    grid.innerHTML = html;
    section && section.classList.remove('is-empty');
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-fm-recent]').forEach((wrap) => {
      if (wrap._fmBound) return;
      wrap._fmBound = true;
      render(wrap);
      if (wrap.dataset.current) remember(wrap.dataset.current);
    });
    const pdp = document.querySelector('[data-fm-product]');
    const handle = document.body.dataset.fmProduct;
    if (pdp && handle) remember(handle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* ==========================================================================
   Falsematter: quick-add sheet + shipping protection opt-out + bag count without protection
   ========================================================================== */
(function () {
  const FM = (window.FM = window.FM || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, o);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const root = (FM.routes && FM.routes.root && FM.routes.root !== '/') ? FM.routes.root.replace(/\/$/, '') : '';
  const money = (c) => (FM.money ? FM.money(c) : (c / 100).toFixed(2));
  const cartUrl = () => (FM.routes && FM.routes.cart) || '/cart';

  /* ---------- protection helpers ---------- */
  const protectProduct = () => { const d = $('[data-fm-cart-drawer]'); return d ? Number(d.dataset.protectProduct || 0) : 0; };
  FM.countOf = (cart) => {
    if (!cart || !cart.items) return cart ? cart.item_count : 0;
    const pid = protectProduct();
    return cart.items.reduce((n, it) => n + (pid && it.product_id === pid ? 0 : it.quantity), 0);
  };
  function patchCart() {
    if (!FM.cart || FM.cart._fmPatched) return;
    FM.cart._fmPatched = true;
    const recount = async () => { try { const c = await fetch(cartUrl() + '.js').then((r) => r.json()); FM.cart.setCount(FM.countOf(c)); if (FM.countOf(c) === 0) { try { sessionStorage.removeItem('fm-protect-off'); } catch (e) {} } } catch (e) {} };
    const origAdd = FM.cart.add.bind(FM.cart);
    const designMode = document.documentElement.classList.contains("shopify-design-mode");
    const optedOut = () => { if (designMode) return false; try { return sessionStorage.getItem("fm-protect-off") === "1"; } catch (e) { return false; } };
    FM.cart.add = async function (items, opts) {
      // add shipping protection in the same request as the first piece, unless the shopper unticked it
      const d = $("[data-fm-cart-drawer]");
      const pv = d ? Number(d.dataset.protectVariant || 0) : 0;
      const wantsDefault = d && d.dataset.protectDefault === "true";
      const row = $("[data-fm-protect]");
      const inCart = row && row.dataset.key;
      const addingProtection = items.some((it) => Number(it.id) === pv);
      if (pv && wantsDefault && !inCart && !addingProtection && !optedOut()) items = items.concat([{ id: pv, quantity: 1 }]);
      const c = await origAdd(items, opts);
      if (c) this.setCount(FM.countOf(c));
      return c;
    };
    const origRefresh = FM.cart.refresh.bind(FM.cart);
    FM.cart.refresh = async function () { await origRefresh(); await recount(); };
    const origChange = FM.cart.change.bind(FM.cart);
    FM.cart.change = async function (key, qty, el) { await origChange(key, qty, el); await recount(); };
    const origRender = FM.cart.render.bind(FM.cart);
    FM.cart.render = function (sections) { origRender(sections); bindProtection(); };
    recount();
  }

  async function syncProtection(row) {
    const box = $('input[type="checkbox"]', row);
    const variant = Number(row.dataset.variant || 0);
    const key = row.dataset.key || '';
    let optedOut = false;
    if (!document.documentElement.classList.contains('shopify-design-mode')) { try { optedOut = sessionStorage.getItem('fm-protect-off') === '1'; } catch (e) {} }
    const wantsDefault = row.dataset.default === 'true';
    if (!box.checked && !key && variant && wantsDefault && !optedOut && !FM._protectTried) {
      FM._protectTried = true;
      try { await FM.cart.add([{ id: variant, quantity: 1 }], { open: false, silent: true }); } catch (e) {}
    }
  }
  function bindProtection() {
    const row = $('[data-fm-protect]');
    if (!row || row._fmBound || !FM.cart) return;
    row._fmBound = true;
    const box = $('input[type="checkbox"]', row);
    on(box, 'change', async () => {
      const key = row.dataset.key;
      const variant = Number(row.dataset.variant || 0);
      try {
        if (box.checked) {
          try { sessionStorage.removeItem('fm-protect-off'); } catch (e) {}
          await FM.cart.add([{ id: variant, quantity: 1 }], { open: false, silent: true });
        } else if (key) {
          try { sessionStorage.setItem('fm-protect-off', '1'); } catch (e) {}
          await FM.cart.change(key, 0);
        }
      } catch (e) {}
    });
    syncProtection(row);
  }
  // when only the protection line remains, drop it so the bag reads as empty
  async function dropLonelyProtection() {
    const pid = protectProduct();
    if (!pid || !FM.cart) return;
    try {
      const c = await fetch(cartUrl() + '.js').then((r) => r.json());
      const others = c.items.filter((it) => it.product_id !== pid);
      const prot = c.items.find((it) => it.product_id === pid);
      if (prot && !others.length) await FM.cart.change(prot.key, 0);
    } catch (e) {}
  }

  /* ---------- quick-add sheet ---------- */
  let sheet;
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('dialog');
    sheet.className = 'fm-quick';
    sheet.innerHTML = '<div class="fm-quick__panel" data-fm-quick-panel></div>';
    document.body.appendChild(sheet);
    on(sheet, 'click', (e) => { if (e.target === sheet) sheet.close(); });
    return sheet;
  }
  async function openQuick(handle) {
    const dlg = ensureSheet();
    const panel = $('[data-fm-quick-panel]', dlg);
    panel.innerHTML = '<p class="fm-quick__loading">Loading…</p>';
    dlg.showModal();
    let p;
    try { p = await fetch(root + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); } catch (e) { panel.innerHTML = '<p class="fm-quick__loading">Could not load this piece.</p>'; return; }
    const opts = p.options.filter((o) => !(o.name === 'Title' && o.values.length === 1 && o.values[0] === 'Default Title'));
    const pos = (o, i) => 'option' + (o.position || i + 1);
    const first = p.variants.find((v) => v.available) || p.variants[0];
    const sel = opts.map((o, i) => (first ? first[pos(o, i)] : o.values[0]));
    const img = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=400' : '';
    const closeSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    panel.innerHTML =
      '<button type="button" class="fm-quick__close" aria-label="Close">' + closeSvg + '</button>' +
      '<div class="fm-quick__head">' + (img ? '<img class="fm-quick__img" src="' + esc(img) + '" alt="">' : '') + '<div><a class="fm-quick__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="fm-quick__price" data-fm-quick-price>' + esc(money(first ? first.price : p.price)) + '</div></div></div>' +
      opts.map((o, i) => '<fieldset class="fm-quick__opt" data-idx="' + i + '"><legend>' + esc(o.name) + ' <span data-fm-quick-val>' + esc(sel[i]) + '</span></legend><div class="fm-quick__vals">' + o.values.map((v) => '<button type="button" class="fm-opt" role="radio" aria-checked="' + (sel[i] === v) + '" data-value="' + esc(v) + '">' + esc(v) + '</button>').join('') + '</div></fieldset>').join('') +
      '<button type="button" class="fm-btn fm-btn--primary fm-btn--lg fm-btn--full fm-quick__atc" data-fm-quick-atc><span class="fm-btn__label">Add to bag</span><span class="fm-btn__spinner" aria-hidden="true"></span></button>' +
      '<a class="fm-quick__more" href="' + esc(p.url) + '">View full details</a>';
    const find = () => p.variants.find((v) => opts.every((o, i) => v[pos(o, i)] === sel[i]));
    const atc = $('[data-fm-quick-atc]', panel);
    const update = () => {
      const v = find();
      $$('.fm-quick__opt', panel).forEach((fs, i) => {
        $$('[data-value]', fs).forEach((b) => b.setAttribute('aria-checked', String(b.dataset.value === sel[i])));
        const lbl = $('[data-fm-quick-val]', fs);
        if (lbl) lbl.textContent = sel[i];
      });
      const price = $('[data-fm-quick-price]', panel);
      if (price && v) price.textContent = money(v.price);
      const label = $('.fm-btn__label', atc);
      if (!v) { atc.disabled = true; label.textContent = 'Unavailable'; }
      else if (!v.available) { atc.disabled = true; label.textContent = 'Sold out'; }
      else { atc.disabled = false; label.textContent = 'Add to bag'; }
    };
    $$('.fm-quick__opt', panel).forEach((fs) => on(fs, 'click', (e) => { const b = e.target.closest('[data-value]'); if (!b) return; sel[Number(fs.dataset.idx)] = b.dataset.value; update(); }));
    on($('.fm-quick__close', panel), 'click', () => dlg.close());
    on(atc, 'click', async () => { const v = find(); if (!v || !v.available) return; try { await FM.cart.add([{ id: v.id, quantity: 1 }], { button: atc, open: true }); dlg.close(); } catch (e) {} });
    update();
  }
  on(document, 'click', (e) => {
    const b = e.target.closest('[data-fm-quick]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    openQuick(b.dataset.fmQuick);
  });

  /* ---------- wire up ---------- */
  function init() { patchCart(); bindProtection(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('fm:cart:added', bindProtection);
  document.addEventListener('fm:cart:changed', () => { bindProtection(); dropLonelyProtection(); });
  document.addEventListener('fm:cart:open', bindProtection);
  document.addEventListener('shopify:section:load', init);
})();
